import { IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Badge, Box } from '@mui/material';
import { NotificationDrawer } from './components/notification-drawer';
import { useGetNotificationTabItems } from './hooks/use-get-notification-tab-items';
import { useSocketNotification } from './socket/use-socket-notification';
import { useNotificationStore } from './store';
import * as Styled from './styles';
import * as SX from './sx';
import { NotificationsProps as Props } from './types';

export const Notifications = ({ className }: Props) => {
  const notifications = useNotificationStore.useNotifications();
  const isDrawerOpen = useNotificationStore.useIsDrawerOpen();
  const openDrawer = useNotificationStore.useOpenDrawer();
  const closeDrawer = useNotificationStore.useCloseDrawer();
  const { sent } = useGetNotificationTabItems(notifications);
  useSocketNotification();

  const iconEl = (
    <Badge badgeContent={sent.length} max={9} color="primary" size={20}>
      <IconButton
        onClick={openDrawer}
        size="small"
        icon="bell"
        iconSize={18}
        aria-label="Open notifications"
      />
    </Badge>
  );

  return (
    <Styled.Wrapper
      className={classnames('Notifications', className)}
      sx={SX.root}
    >
      <Box sx={SX.iconBox}>{iconEl}</Box>
      <NotificationDrawer open={isDrawerOpen} onClose={closeDrawer} />
    </Styled.Wrapper>
  );
};

Notifications.displayName = 'Notifications';
